<template>
  <div style="height: 800px;">
    <div class="block input without-footer">
      <div class="header" @click="displayForm = !displayForm" style="cursor:pointer;">目標貯水位の入力</div>
      <div v-if="displayForm" class="body2" style="width: 50%; float: left; height: 200px;">
        <div>
          目標日時 (最長11日) <b-form-input id="date_interval" v-model="date_interval" size="1" placeholder=""></b-form-input>日後
          <!--
          の<b-form-datepicker id="datepicker" v-model="date" placeholder="未指定" class="datepicker"></b-form-datepicker>
          -->
          に 
        </div>
        <div>
          <span class="green">目標貯水位</span> 
          <b-form-input style="width: 100px;" id="targetlevel" v-model="targetlevel" size="1" placeholder=""></b-form-input>
          <span class="green">m</span>  になるように <b-button id="calcualte" @click="onClickCalculate($refs.linechart)">計算</b-button>
        </div>
      </div>
      <div v-if="displayForm" class="body3" style="width: 50%; float: right; height: 200px;">
        <div style="width: 70%; height: 160px; background-color: #fff; border: 4px solid rgba(57,50 ,178,1); margin: auto;">
          <div style="width: 100%; height: 40px; background-color: rgba(57,50 ,178,1); text-align: center; padding-top: 8px; color: #fff; font-size: 16px; font-weight: bold;">
            <span style="padding-top: 5px;">
              事前放流可能水位
            </span>
          </div>
          <div v-if="!imp_flag" style="width: 100%; height: 40px; background-color: #fff; text-align: center; padding-top: 14px; color: rgba(57,50 ,178,1); font-size: 37px; font-weight: bold;">
            <span>
              {{ this.predictWaterLevelsAfterDischarge[0].toFixed(2) }}m <span style="font-size: 14px;">まで水位を下げることが可能</span>
            </span>
          </div>
          <div v-if="!imp_flag" style="width: 100%; height: 40px; background-color: #fff; text-align: center; padding-top: 28px; color: rgba(57,50 ,178,1); font-size: 18px; font-weight: bold;">
            <span>
              差 {{ (this.predictWaterLevelsAfterDischarge[0] - this.startlevel).toFixed(2) }}m
            </span>
          </div>
          <div v-else style="width: 100%; height: 40px; background-color: #fff; text-align: center; padding-top: 30px; color: rgba(57,50 ,178,1); font-size: 30px; font-weight: bold;">
            <span>
              事前放流不可
            </span>
          </div>
        </div>
      </div>
      <div v-if="!displayForm" class="footer"></div>
    </div>
    
    <div class="block">
      <div class="header" @click="displayChart = !displayChart" style="cursor:pointer;">事前放流可能水位グラフ</div>
      <div v-if="displayChart" class="body" @mousemove="onMouseMove($event, $refs.linechart)">
        <LineChartGenerator
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
        ref="linechart"
      />
      </div>
      <div v-if="displayChart" class="footer">
        <div>
      <!--
          <button @click="onClickRange($refs.linechart, 12 )">12時間</button>
          <button @click="onClickRange($refs.linechart, 24 )">1日</button>
          <button @click="onClickRange($refs.linechart, 24*3 )">3日</button>
          <button @click="onClickRange($refs.linechart, 24*7 )">7日</button>
          <button @click="onClickRange($refs.linechart, 24*30 )">30日</button>
      -->
        </div>
        <div>
          <button @click="onClickZoomOut($refs.linechart)">-</button>
          <button @click="onClickZoomIn($refs.linechart)">+</button>
          <button @click="onClickResetZoom($refs.linechart)">リセット</button>
        </div>
      </div>
      <div v-if="!displayChart" class="footer"></div>
    </div>
  </div>
  
</template>
  
<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import annotationPlugin from 'chartjs-plugin-annotation'; // アノテーション描画で必要
import zoomPlugin from 'chartjs-plugin-zoom';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
  TimeScale,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  TimeScale,
  PointElement,
  Filler
  ,annotationPlugin  // アノテーション描画で必要
  , zoomPlugin
)

// Bootstrap-Vue references : 
// https://bootstrap-vue.org/docs/components/form-input
// https://bootstrap-vue.org/docs/components/form-datepicker

export default {
  name: 'PreDischargeLineChart',
  components: {
    LineChartGenerator
  }
  ,
  created() {
    this.startlevel = this.item.waterlevel.level[this.item.waterlevel.level.length-1];
		// this.targetlevel = this.item.targetlevel;
    this.apcp = Object.assign({},this.item.apcp);
    this.waterlevel = this.item.waterlevel.level.concat();
    this.chartData.labels = this.item.waterlevel.ts.concat();
		let data = this.setPreDischargeData();
    this.setChartData(data);
  }
  ,
  mounted() {
	}
  ,
  props: {
    chartId: {
      type: String,
      default: 'block-water-history'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    // plugins: {
    //   type: Array,
    //   default: () => []
    // }
    // ,
    item: {
      type: Object,
      default: () => []
    }
  },
  computed: {
  },
  data() { 
    return {
      displayChart: false,
      displayForm: true,
      date_interval: 11,
      date: new Date(),
      chart:null,
      chartData: {},
      chartOptions: {},
      legend_width: 150,
      imp_flag: false,
      thresholds: function() { return this.$store.getters.getDischargeParams }
      // {
      //   fulllevel : { v: null, color: '#008900', text_color:'white', name:'常時満水位', draw_line: true, draw_legend: true }
      //   ,targetlevel : { v: null, color: '#2EAE00', text_color:'white', name:'目標貯水位', draw_line: true, draw_legend: true }
      //   ,discharge_level : { v: 0, color: 'rgba(57,50 ,178,1)', text_color:'white', name:'事前放流可能水位', draw_line: false, draw_legend: true }
      //   ,predicted_level_bottom : { v: null, color: '#00AEAC', text_color:'black', name:'予測回復水位（下限値）', draw_legend: true }
      //   ,predicted_level_middle : { v: null, color: '#93F7FF', text_color:'black', name:'予測回復水位（中央値）', draw_legend: true }
      //   ,water_level : { v: null, color: 'rgba(113,192,255,0.8)', text_color:'black', name:'観測水位', draw_legend: true }
        
      // }
      ,
			startlevel: null,
      targetlevel: -1.0,
      waterlevel: null,
			apcp: {},
			predictWaterLevelsAfterDischarge: null,
			predictWaterLevelsAfterDischargeMiddle: null,
			log: "",
      plugins: [
          {
            // 特殊なレジェンドの作成
            id: 'custom_legends',
            beforeDraw: (function (chart) {
              // console.log(chart)
              try{
                const w = this.legend_width
                let h = 50
                const scales = chart.scales
                const chartArea = chart.chartArea
                // const thresholds = this.item.alertThresholds
                // const c = this.$store.getters.getColors
                let y = 0
                let ctx = chart.ctx;

                const xpos_0 = chartArea.left + chartArea.width 
                const xpos_1 = chart.width - w

                for(let key in this.thresholds()){
                  const target_item = this.thresholds()[key]
                  // console.log(scales,xpos_0,xpos_1)
                  if(target_item.draw_legend){
                    let ypos = null;
                    let the_level = null;
                    if(target_item.name == "常時満水位"){
                      the_level =  0
                      ypos = scales.water_level.getPixelForValue( the_level )
                    } else if(target_item.name == "目標貯水位"){
                      the_level =  this.targetlevel 
                      ypos = scales.water_level.getPixelForValue( the_level )
                    } else if(target_item.name == "事前放流可能水位"){
                      if (!this.imp_flag) {
                        the_level =  new Intl.NumberFormat().format( this.predictWaterLevelsAfterDischarge[0].toFixed(2) ) 
                        ypos = scales.water_level.getPixelForValue( the_level )
                      }
                    }
                    if(target_item.name == "事前放流可能水位"){
                      h = 75
                    } else {
                      h = 50
                    }
                    if(target_item.name == "予測回復水位（中央値）" || target_item.name == "観測水位"){
                      if ((target_item.name == "予測回復水位（中央値）" && !this.imp_flag) || target_item.name == "観測水位") {
                        h = 40
                        ctx.fillStyle = target_item.color;
                        ctx.fillRect(chart.width - w, y, w, h);
                        ctx.fillStyle = target_item.text_color;
                        ctx.font = "bold 13px sans-serif";
                        ctx.textAlign = "center";
                        ctx.fillText( target_item.name, chart.width  - w * 0.5, y + 25);
                      }
                    } else if(target_item.name == "予測回復水位（下限値）"){
                      if (!this.imp_flag) {
                        y += 20
                        h = 40
                        ctx.beginPath () ;
                        ctx.strokeStyle = target_item.color;
                        ctx.lineWidth = 4 ;
                        ctx.setLineDash([5, 5]);
                        ctx.moveTo( chart.width - w, y ) ;
                        ctx.lineTo( chart.width, y ) ;
                        ctx.stroke() ;
                        // ctx.fillStyle = target_item.color;
                        // ctx.fillRect(chart.width - w, y, w/3, h);
                        ctx.fillStyle = target_item.text_color;
                        ctx.font = "bold 13px sans-serif";
                        ctx.textAlign = "center";
                        ctx.fillText( target_item.name, chart.width  - w * 0.5, y+25);
                        ctx.setLineDash([]);
                      }
                    } else {
                      if (target_item.name == "事前放流可能水位" && this.imp_flag) {
                        console.log();
                      } else {
                        ctx.fillStyle = target_item.color;
                        ctx.fillRect(chart.width - w, y, w, h);
                        ctx.fillStyle = target_item.text_color;
                        ctx.font = "bold 16px sans-serif";
                        ctx.textAlign = "center";
                        ctx.fillText( target_item.name, chart.width  - w/2, y+18);
                        ctx.font = "bold 24px sans-serif";
                        if (target_item.name == "常時満水位") {
                          ctx.fillText( '0.00m' , chart.width  - w/2, y+45);
                        } else {
                          ctx.fillText( the_level + 'm' , chart.width  - w/2, y+45);
                        }
                      }
                      if(target_item.name == "事前放流可能水位") {
                        if (!this.imp_flag) {
                          ctx.font = "bold 14px sans-serif";
                          ctx.fillText( (this.predictWaterLevelsAfterDischarge[0] - this.startlevel).toFixed(2) + ' m差' , chart.width  - w/2, y+65);
                        }
                      }
                      if(target_item.draw_line){
                        ctx.beginPath () ;
                        ctx.strokeStyle = target_item.color;
                        ctx.lineWidth = 2 ;
                        ctx.moveTo( chartArea.left, ypos ) ;
                        ctx.lineTo( xpos_0, ypos ) ;
                        ctx.stroke() ;

                        ctx.beginPath () ;
                        ctx.strokeStyle = target_item.color;
                        ctx.lineWidth = 2 ;
                        
                        ctx.moveTo( xpos_0, ypos ) ;
                        ctx.lineTo( xpos_1, y + h/2 )
                        
                        ctx.stroke() ;
                      }
                    }
                    y += h+5
                  }
                }
                // 単位
                ctx.textAlign = 'left';
                ctx.fillStyle = "#555";
                ctx.font = "normal 14px sans-serif";
                ctx.fillText('水位(m)', 10, 14 );
                ctx.restore();

              } catch( e){
                  console.log(e)
              }
            }).bind(this)
          }
        ]
    }
  }
  ,methods : {
    onClickCalculate(c){
      if (this.date_interval > 0 && this.date_interval < 12) {
        let data = this.setPreDischargeData();
        this.setChartData(data);
      } else {
        alert("目標日時は1日〜11日の間で設定して下さい");
      }
    }
    ,
    onClickRange(e,r){
      console.log(e,r)
    },
    onClickZoomIn(e){
      let chart = e.getCurrentChart()
      if(chart.getZoomLevel() < 10){
        chart.zoom( 1.2 , 'x')
      }
    }
    ,
    onClickZoomOut(e){
      let chart = e.getCurrentChart()
      chart.zoom( 0.8 , 'x')
    }
    ,
    onClickResetZoom(e){
      let chart = e.getCurrentChart()
      chart.resetZoom()
    }
    ,
    onMouseMove(e, c){
      // console.log(e,c)
      let chart = c.getCurrentChart()
      let area = chart.chartArea
      if(area.left -10 < e.offsetX && e.offsetX < area.left + area.width +10 && area.top - 10  < e.offsetY && e.offsetY < area.top+area.height + 10){
        document.body.classList.add('can-zoom')
      } else {
        document.body.classList.remove('can-zoom')
      }
    }
    ,
    scrollTop: function() {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		},
		logStr: function(array) {
			let str = "[ ";
			for (var i = 0; i < array.length; i++) {
				let val = Math.round(array[i] * 100.0) / 100.0;
				if (i == array.length-1) str += val;
				else str += val + ", ";
			}
			return str + " ]";
		},
		reloadGraph: function() {
			this.log = "";
			if (this.targetlevel > this.item.fulllevel) this.targetlevel = this.item.fulllevel;
			if (this.targetlevel < 0.5) this.targetlevel = 0.5;
			if (this.startlevel > this.targetlevel)
				this.startlevel = this.targetlevel;
			if (this.startlevel < 0.1) this.startlevel = 0.1;
			this.setPreDischargeData();
		},
		calcAll: function() {
      let apcp = this.calcMiddleAPCP();
			let acm_apcp = this.calcAcmAPCP(apcp);
      // console.log("ACM APCP: " + JSON.stringify(acm_apcp));
			let acm_storage = [];
			let daily_storage = [];
      let current_level = this.item.waterlevel.level[this.item.waterlevel.level.length-1] + this.item.fulllevel;
			this.log += "積算雨量: " + this.logStr(acm_apcp) + "\n";
			for (let i = 0; i < this.date_interval; i++) {
				acm_storage[i] = acm_apcp[i] * this.item.regressionCoefficient;
				// acm_storage[i] = acm_apcp[i] * this.item.regressionBottomCoefficient + this.item.regressionBottomOffset;
				if (acm_storage[i] <= 0) acm_storage[i] = 0;
				if (i == 0) daily_storage[i] = acm_storage[i];
				else if (acm_storage[i] == 0) daily_storage[i] = 0;
				else daily_storage[i] = acm_storage[i] - daily_storage[i - 1];
			}
			let targetWaterArea =
				this.item.pondBottomArea + this.item.c * (parseFloat(this.targetlevel) + this.item.fulllevel);
			let targetWaterStorage =
				(targetWaterArea + this.item.pondBottomArea) * (parseFloat(this.targetlevel) + this.item.fulllevel) * 0.5;
			// console.log("recovery water storage: " + daily_storage);
			// console.log("target water storage: " + targetWaterStorages[0]);
			this.log += "日回復貯水量: " + this.logStr(daily_storage) + "\n";
			this.log += "目標貯水量: " + this.logStr([targetWaterStorage]) + "\n";
			// ここから予測貯水量の計算
		
			// 事前放流した場合の予測貯水量を計算する
			this.predictWaterLevelsAfterDischarge = [];
			let predictWaterStoragesAfterDischarge = [];
      this.imp_flag = false;
			for (let i = 0; i < daily_storage.length; i++) {
				if (i == 0)
					predictWaterStoragesAfterDischarge[i] =
						targetWaterStorage - daily_storage[daily_storage.length - 1 - i];
				else
					predictWaterStoragesAfterDischarge[i] =
						predictWaterStoragesAfterDischarge[i - 1] -
						daily_storage[daily_storage.length - 1 - i];
				// if (predictWaterStoragesAfterDischarge[i] <= 0)
				// 	this.predictWaterLevelsAfterDischarge[i] = 0;
				// else
					this.predictWaterLevelsAfterDischarge[i] =
						this.item.vh[0] * predictWaterStoragesAfterDischarge[i] +
						this.item.vh[1] *
							Math.pow(predictWaterStoragesAfterDischarge[i], 2.0) +
						this.item.vh[2] *
							Math.pow(predictWaterStoragesAfterDischarge[i], 3.0) +
						this.item.vh[3] *
							Math.pow(predictWaterStoragesAfterDischarge[i], 4.0) +
						this.item.vh[4] *
							Math.pow(predictWaterStoragesAfterDischarge[i], 5.0) +
						this.item.vh[5];
          this.predictWaterLevelsAfterDischarge[i] = this.predictWaterLevelsAfterDischarge[i] - this.item.fulllevel;
          // console.log("Compare: " + this.predictWaterLevelsAfterDischarge[i] + " / " + this.targetlevel);
          // if (this.predictWaterLevelsAfterDischarge[i] > parseFloat(this.targetlevel) + 0.0001) {
          //   this.imp_flag = true;
          //   this.predictWaterLevelsAfterDischarge[i] = null;
          // }
			}
			this.log +=
				"予測貯水位 (中央値): " + this.logStr(this.predictWaterLevelsAfterDischarge) + "\n";
			this.log +=
				"予測貯水量 (中央値): " +
				this.logStr(predictWaterStoragesAfterDischarge) +
				"\n";
      if (this.predictWaterLevelsAfterDischarge[0] > parseFloat(this.targetlevel) || this.predictWaterLevelsAfterDischarge[0] < parseFloat(this.targetlevel) - 0.5 || this.predictWaterLevelsAfterDischarge[this.predictWaterLevelsAfterDischarge.length-1] > parseFloat(this.startlevel)) {
        this.imp_flag = true;
      }
      if (this.imp_flag) {
        for (let i = 0; i < this.predictWaterLevelsAfterDischarge.length; i++) {
          this.predictWaterLevelsAfterDischarge[i] = null;
        }
      } else {
        this.predictWaterLevelsAfterDischarge = this.predictWaterLevelsAfterDischarge.reverse();
        predictWaterStoragesAfterDischarge = predictWaterStoragesAfterDischarge.reverse();
      }
			// 下限値について事前放流ありの場合の予測貯水位を計算する
			let middle_daily_storage = [];
			acm_storage = [];
			for (let i = 0; i < this.date_interval; i++) {
				// acm_storage[i] = acm_apcp[i] * this.item.regressionCoefficient;
				acm_storage[i] =
					acm_apcp[i] * this.item.regressionBottomCoefficient +
					this.item.regressionBottomOffset;
				if (acm_storage[i] <= 0) acm_storage[i] = 0;
				if (i == 0) middle_daily_storage[i] = acm_storage[i];
				else if (acm_storage[i] == 0) middle_daily_storage[i] = 0;
				else
					middle_daily_storage[i] =
						acm_storage[i] - middle_daily_storage[i - 1];
			}
			this.log += "日回復貯水量 (下限値): " + this.logStr(middle_daily_storage) + "\n";
			// ここから下限値についての予測貯水位と予測貯水量の計算
			this.predictWaterLevelsAfterDischargeMiddle = [];
			let predictWaterStoragesAfterDischargeMiddle = [];
			for (let i = 0; i < middle_daily_storage.length; i++) {
				if (i == 0)
					predictWaterStoragesAfterDischargeMiddle[i] =
						targetWaterStorage - middle_daily_storage[middle_daily_storage.length - 1 - i];
				else
					predictWaterStoragesAfterDischargeMiddle[i] =
						predictWaterStoragesAfterDischargeMiddle[i - 1] -
						middle_daily_storage[middle_daily_storage.length - 1 - i];
				// if (predictWaterStoragesAfterDischargeMiddle[i] <= 0)
				// 	this.predictWaterLevelsAfterDischargeMiddle[i] = 0;
				// else
					this.predictWaterLevelsAfterDischargeMiddle[i] =
						this.item.vh[0] * predictWaterStoragesAfterDischargeMiddle[i] +
						this.item.vh[1] *
							Math.pow(predictWaterStoragesAfterDischargeMiddle[i], 2.0) +
						this.item.vh[2] *
							Math.pow(predictWaterStoragesAfterDischargeMiddle[i], 3.0) +
						this.item.vh[3] *
							Math.pow(predictWaterStoragesAfterDischargeMiddle[i], 4.0) +
						this.item.vh[4] *
							Math.pow(predictWaterStoragesAfterDischargeMiddle[i], 5.0) +
						this.item.vh[5];
          this.predictWaterLevelsAfterDischargeMiddle[i] = this.predictWaterLevelsAfterDischargeMiddle[i] - this.item.fulllevel;
            // console.log("Compare2: " + this.predictWaterLevelsAfterDischargeMiddle[i] + " / " + this.targetlevel);
            if (this.predictWaterLevelsAfterDischargeMiddle[i] > parseFloat(this.targetlevel)) {
              // this.imp_flag = true;
              this.predictWaterLevelsAfterDischargeMiddle[i] = null;
            }
			}
			this.log +=
				"予測貯水位 (下限値): " + this.logStr(this.predictWaterLevelsAfterDischargeMiddle) + "\n";
			this.log +=
				"予測貯水量 (下限値): " +
				this.logStr(predictWaterStoragesAfterDischargeMiddle) +
				"\n";
      if (this.imp_flag) {
        for (let i = 0; i < this.predictWaterLevelsAfterDischargeMiddle.length; i++) {
          this.predictWaterLevelsAfterDischargeMiddle[i] = null;
        }
      } else {
        this.predictWaterLevelsAfterDischargeMiddle = this.predictWaterLevelsAfterDischargeMiddle.reverse();
        predictWaterStoragesAfterDischargeMiddle = predictWaterStoragesAfterDischargeMiddle.reverse();
      }		
		},
    calcMiddleAPCP: function() {
      let data = [];
			for (const key of Object.keys(this.apcp)) {
        let ensemble = this.apcp[key];
        let ensVal = ensemble[2] + ensemble[3] + ensemble[4];
        data.push({"id": key, "value": ensVal});
      }
      data.sort((a, b) => a.value - b.value);
      return this.apcp[data[5].id];
    },
		calcAcmAPCP: function(apcp) {
			let acm_apcp = [];
			let total = 0;
			for (var i = 0; i < this.date_interval; i++) {
        if (!apcp[i]) apcp.push(0);
				if (apcp[i] != 0) {
					acm_apcp[i] = apcp[i] + total;
					total += apcp[i];
				} else {
					acm_apcp[i] = 0;
					total = 0;
				}
			}
			// console.log(acm_apcp);
			// this.log += "積算雨量: " + this.logStr(acm_apcp) + "\n";
			return acm_apcp;
		},
		setPreDischargeData: function() {
      let data = {
        labels:[] // 日時
        ,water_level: [] // 観測水位
        ,predicted_level_middle:[] //予測回復水位
        ,predicted_level_bottom:[] //予測回復水位
      }
      // console.log(this.waterlevel);
      if (!this.waterlevel) return;
      for (let i = 0; i < this.waterlevel.length; i++) {
        if (typeof this.chartData.labels[i] == "string") {
          this.chartData.labels[i] = new Date(this.chartData.labels[i]);
        }
        data.labels.push(this.chartData.labels[i]);
        data.water_level.push(this.waterlevel[i]);
        if (i != this.waterlevel.length-1) {
          data.predicted_level_middle.push(null);
          data.predicted_level_bottom.push(null);
        }
			}
      // ここから予測計算
			this.calcAll();
      let prev = new Date(data.labels[data.labels.length-1].getTime());
      let interval = 60 * 24;
			for (let i = 0; i < this.predictWaterLevelsAfterDischarge.length; i++) {
				prev = new Date(prev.setMinutes(prev.getMinutes() + interval));
        data.labels.push(new Date(prev.getTime()));
        data.water_level.push(null);
        data.predicted_level_middle.push(this.predictWaterLevelsAfterDischargeMiddle[i]);
        data.predicted_level_bottom.push(this.predictWaterLevelsAfterDischarge[i]);
			}
			// 11日後
      data.labels.push(prev)
      data.water_level.push(null)
      data.predicted_level_middle.push(this.targetlevel)
      data.predicted_level_bottom.push(this.targetlevel)
			prev = new Date(prev.setMinutes(prev.getMinutes() + interval));
			// 11日後以降のデータ
			for (var i = 0; i < 3; i++) {
				prev = new Date(prev.setMinutes(prev.getMinutes() + interval));
        data.labels.push(new Date(prev.getTime()));
        data.water_level.push(null);
        data.predicted_level_middle.push(null);
        data.predicted_level_bottom.push(null);
			}
      console.log(this.log);
      return data;
		},
    setChartData: function(data) {
      if (this.imp_flag) {
        this.chartData = {
          labels: null
          ,
          datasets: [
            {
              label: '水位'
              ,fill : "start"
              ,backgroundColor: 'rgba(113,192,255,0.8)'
              ,borderColor: "#3e95cd"
              ,borderWidth: 0
              ,data: null
              ,yAxisID: 'water_level'
            }
          ]
        };
        this.chartOptions = {
          responsive: true,
          maintainAspectRatio: false
          ,
          layout: {
              padding: {
                right: 150 + 50
                ,top: 30
              }
          }
          ,
          scales: {
            x: {
              ticks: {
                  callback: function(val) { // , index
                  // let num_ticks = this.ticks.length
                  let s = ''
                  // if(index % (num_ticks-1) === 0 || index % Math.floor(num_ticks / 20) === 0 ){
                  let ds = new Date( this.getLabelForValue(val) )
                  s = (ds.getMonth() + 1) + '/' + ds.getDate() + ' ' + ('0' + ds.getHours()).slice(-2) + ':' + ('0' + ds.getMinutes()).slice(-2); 
                  // }
                  return s;
                },
                color: 'black',
              }
            }
            ,
            water_level: {
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                stepSize: 0.2
              },
              min: (function(){ return Math.min(...this.item.waterlevel.level.concat([parseFloat(this.item.fulllevel), parseFloat(this.targetlevel)]).concat(this.predictWaterLevelsAfterDischarge)) - 0.5}).bind(this),
              max: (function(){ return Math.max(...this.item.waterlevel.level.concat([parseFloat(this.item.fulllevel), parseFloat(this.targetlevel)]).concat(this.predictWaterLevelsAfterDischarge)) + 0.5}).bind(this)
            },
          },
          plugins: {
              tooltip: {
                  callbacks: {
                    title: function(context){
                      let title = new Date(context[0].label);
                      return title.getFullYear() + '/' + (title.getMonth() + 1) + '/' + title.getDate() + ' ' + ('0' + title.getHours()).slice(-2) + ':' + ('0' + title.getMinutes()).slice(-2)
                    },
                    label: function(context) {
                        let label = context.dataset.label || '';

                        if (label) {
                            label += ' : ';
                        }
                        if (context.parsed.y !== null) {
                            label += new Intl.NumberFormat('en-US', { style: 'decimal', maxDigits: 2 }).format(context.parsed.y) + ' m';
                        }
                        return label;
                    }
                  }
              },
              legend: {
                display: false,
                position: 'right'
              },
              zoom:{
                limits:{
                  // x : { min: 20, max: 100 }
                },
                zoom : {
                  wheel : {
                    enabled: true,
                    speed : 0.01
                  }
                  ,mode : 'x'
                }
                ,pan : {
                    enabled: true
                    ,mode : 'x'
                  }
              }
              , autocolors: false
              , annotation: { // チャート内に線やボックスを描ける
                  animations: {
                    numbers: {
                      properties: [], // keep empty to avoid a bug // 'x', 'y', 'x2', 'y2', 'width', 'height', 'radius'
                      type: 'number'
                    },
                  },
                  annotations: {
                    label2: {
                      type: 'label',
                      xValue: (function(){ return this.waterlevel.length + 1.25}).bind(this),
                      yValue: (function(){ return this.waterlevel[this.waterlevel.length-1]}).bind(this) ,
                      textAlign : 'left', 
                      color: 'rgba(57,50 ,178,1)',
                      backgroundColor: 'rgba(255,255,255,0)',
                      content: ['事前放流不可'],
                      font: {
                        size: 18
                        ,weight:'bold'
                      }
                    }
                  }
              }
            
          }
        }
      } else {
        this.chartData = {
          labels: null,
          datasets: [
            {
              label: '水位'
              ,fill : "start"
              ,backgroundColor: 'rgba(113,192,255,0.8)'
              ,borderColor: "#3e95cd"
              ,borderWidth: 0
              ,data: null
              ,yAxisID: 'water_level'
            },
            {
              label: '予測回復水位 (下限値)'
              ,fill : false
              ,borderColor: 'rgba(0,174,172,1)'
              ,backgroundColor: "#1560FF"
              ,borderWidth: 2
              ,borderDash : [3, 3]
              ,data: null
              ,yAxisID: 'water_level'
            },
            {
              label: '予測回復水位 (中央値)'
              ,fill : "start"
              ,borderColor: 'rgba(107,207,215,1)'
              ,backgroundColor: 'rgba(147,247,255,0.6)'
              ,borderWidth: 1
              ,data: null
              ,yAxisID: 'water_level'
            }
          ]
        };
        this.chartOptions = {
          responsive: true,
          maintainAspectRatio: false
          ,
          layout: {
              padding: {
                right: 150 + 50
                ,top: 30
              }
          }
          ,
          scales: {
            x: {
              ticks: {
                callback: function(val) { // , index
                  // let num_ticks = this.ticks.length
                  let s = ''
                  // if(index % (num_ticks-1) === 0 || index % Math.floor(num_ticks / 20) === 0 ){
                  let ds = new Date( this.getLabelForValue(val) )
                  s = (ds.getMonth() + 1) + '/' + ds.getDate() + ' ' + ('0' + ds.getHours()).slice(-2) + ':' + ('0' + ds.getMinutes()).slice(-2); 
                  // }
                  return s;
                },
                color: 'black',
              }
            },
            water_level: {
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                stepSize: 0.2
              },
              min: (function(){ return Math.min(...this.item.waterlevel.level.concat([0, parseFloat(this.targetlevel)]).concat(this.predictWaterLevelsAfterDischarge)) - 0.5}).bind(this),
              max: (function(){ return Math.max(...this.item.waterlevel.level.concat([0, parseFloat(this.targetlevel)]).concat(this.predictWaterLevelsAfterDischarge)) + 0.5}).bind(this)
              // min: (function(){ return this.predictWaterLevelsAfterDischarge[0] - 0.1 }).bind(this),
              // max: (function(){ return this.fulllevel + 0.1 }).bind(this)
            },
          },
          plugins: {
              tooltip: {
                  callbacks: {
                    title: function(context){
                      let title = new Date(context[0].label);
                      return title.getFullYear() + '/' + (title.getMonth() + 1) + '/' + title.getDate() + ' ' + ('0' + title.getHours()).slice(-2) + ':' + ('0' + title.getMinutes()).slice(-2)
                    },
                    label: function(context) {
                        let label = context.dataset.label || '';

                        if (label) {
                            label += ' : ';
                        }
                        if (context.parsed.y !== null) {
                            label += new Intl.NumberFormat('en-US', { style: 'decimal', maxDigits: 2 }).format(context.parsed.y) + ' m';
                        }
                        return label;
                    }
                  }
              },
              legend: {
                display: false,
                position: 'right'
              },
              zoom:{
                limits:{
                  // x : { min: 20, max: 100 }
                },
                zoom : {
                  wheel : {
                    enabled: true,
                    speed : 0.01
                  }
                  ,mode : 'x'
                }
                ,pan : {
                    enabled: true
                    ,mode : 'x'
                  }
              }
              , autocolors: false
              , annotation: { // チャート内に線やボックスを描ける
                  animations: {
                    numbers: {
                      properties: [], // keep empty to avoid a bug // 'x', 'y', 'x2', 'y2', 'width', 'height', 'radius'
                      type: 'number'
                    },
                  },
                  annotations: {
                    box1: { // black line
                      type: 'box',
                      xMin:  (function(){ return this.waterlevel.length+this.predictWaterLevelsAfterDischarge.length-1 }).bind(this),
                      xMax: (function(){ return this.waterlevel.length+this.predictWaterLevelsAfterDischarge.length-1 }).bind(this),
                      yMin: (function(){ return this.predictWaterLevelsAfterDischarge[0] - 1 }).bind(this),
                      yMax: (function(){ return 0.1 }).bind(this) ,
                      borderWidth : 3,
                      backgroundColor: 'rgba(0,0 ,0,1)',
                      borderColor: 'rgba(0,0 ,0,1)'
                    }
                    ,label1: {
                      type: 'label',
                      xValue:  (function(){ return this.waterlevel.length+this.predictWaterLevelsAfterDischarge.length-1 }).bind(this),
                      yValue:  (function(){ return 0.2 }).bind(this) ,
                      textAlign : 'center', 
                      color: 'rgba(0,0,0,1)',
                      backgroundColor: 'rgba(255,255,255,1)',
                      content: (function(){ 
                        const target_date = this.chartData.labels[ this.waterlevel.length + this.predictWaterLevelsAfterDischarge.length-1 ] 
                        return [
                          target_date.getFullYear()+'/'+(target_date.getMonth()+1)+'/'+(target_date.getDate()) 
                        ]
                      }).bind(this),
                      font: {
                        size: 18
                        ,weight:'bold'
                      }
                    }
                    ,
                    box2: { // blue line
                      type: 'box',
                      xMin:  (function(){ return this.waterlevel.length - 1}).bind(this),
                      xMax:  (function(){ return this.waterlevel.length - 1}).bind(this),
                      yMin: (function(){ return this.predictWaterLevelsAfterDischarge[0] }).bind(this),
                      yMax: (function(){ return this.waterlevel[ this.waterlevel.length - 1 ] }).bind(this),
                      borderWidth : 3,
                      backgroundColor: 'rgba(57,50 ,178,1)',
                      borderColor: 'rgba(57,50 ,178,1)'
                    }
                    ,label2: {
                      type: 'label',
                      xValue: (function(){ return this.waterlevel.length - 1}).bind(this),
                      yValue: (function(){ return this.predictWaterLevelsAfterDischarge[0] - 0.25 }).bind(this) ,
                      textAlign : 'left', 
                      color: 'rgba(57,50 ,178,1)',
                      backgroundColor: 'rgba(255,255,255,0)',
                      content: ['事前放流'],
                      font: {
                        size: 18
                        ,weight:'bold'
                      }
                    }
                    ,triangle: { // blue  triangle
                      // drawTime: 'afterDraw',
                      type: 'polygon',
                      xValue: (function(){ return this.waterlevel.length - 1}).bind(this),
                      yValue:  (function(){ return this.predictWaterLevelsAfterDischarge[0] + 0.05 }).bind(this) ,
                      sides: 3,
                      radius: 10,
                      rotation : 180,
                      borderWidth : 0 ,
                      backgroundColor: 'rgba(57,50 ,178,1)'
                    }
                    ,
                  }
              }
            
          }
        }
      }
      this.chartData.labels = data.labels;
      this.chartData.datasets[0].data = data.water_level;
      if (!this.imp_flag) {
        this.chartData.datasets[1].data = data.predicted_level_middle;
        this.chartData.datasets[2].data = data.predicted_level_bottom;
      }
    }
  }
}
</script>
<style lang="scss">
.input {
  .body > div, .body2 > div, .body3.div { 
    display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 18px; margin: 1em auto;  
    span.green { background-color: transparent !important; color: #17A22B ;  }
    #datepicker__outer_ { width: 30%; margin: 0 .5em;  }
    input {
      margin: 0 .5em; 
      &#date_interval { width: 60px; }
      &#targetlevel { width: 120px; color: #17A22B; }
    }
    button#calcualte { background-color:#3932B2; margin: 0 .5em;  }
  }
}
</style>